<template>
    <b-navbar toggleable="lg" type="dark" variant="primary">
        <b-navbar-brand>
            <b-button
                pressed
                variant="primary"
                @click="$emit('toggle-sidebar')"
            >
                <b-icon icon="list"></b-icon>
            </b-button>
            &nbsp;&nbsp;

            <router-link
                to="/"
                class="h4 mb-0 text-lg text-white text-uppercase d-none d-lg-inline-block"
                >OMS</router-link
            >
            <span v-for="(path, key) in paths" :key="`span-${key}`">
                <span
                    class="h4 mb-0 text-lg text-white text-uppercase d-none d-lg-inline-block"
                    >&nbsp;/&nbsp;</span
                >
                <router-link
                    :to="path.path"
                    class="h4 mb-0 text-lg text-white text-uppercase d-none d-lg-inline-block"
                    :key="key"
                    >{{ path.text | capitalize }}</router-link
                >
            </span>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <b-nav-item-dropdown right>
                    <!-- Using 'button-content' slot -->
                    <template #button-content>
                        <em>{{ user.first_name}} {{user.last_name}} ({{user.roles[0].role.name}}) {{companySetting.name}}</em>
                    </template>
                    <b-dropdown-item to="/admin/profile"
                        >Profile</b-dropdown-item
                    >
                    <b-dropdown-item @click="logout()"
                        >Sign Out</b-dropdown-item
                    >
                </b-nav-item-dropdown>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>
<script>
import { capitalCase } from 'change-case'
export default {
    data() {
        return {
            activeNotifications: false,
            showMenu: false,
            searchQuery: '',
            paths: [],
        }
    },
    filters: {
        capitalize(x) {
            return capitalCase(x)
        },
    },
    computed: {
        user() {
            return this.$store.state.user || {}
        },
        companySetting() {
            const data = this.$store.state.company.settings
            return data
        },
    },

    watch: {
        $route() {
            this.calcPath()
        },
    },
    mounted() {
        this.calcPath()
        this.$store.dispatch('company/fetch')
    },

    methods: {
        calcPath() {
            // generate path
            let pathSplit = this.$route.path.split('/')
            pathSplit.splice(0, 1) // remove

            let paths = []
            let runningPath = ''
            for (let segment of pathSplit) {
                runningPath += '/' + segment

                paths.push({
                    path: runningPath,
                    text: segment,
                })
            }
            this.paths = paths
        },

        toggleMenu() {
            this.showMenu = !this.showMenu
        },
        logout() {
            this.$store.dispatch('logout')
            this.$router.push('/login')
            return false
        },
    },
}
</script>

<style scoped>
.avatar-border {
    border: solid white 2px;
}

.pointer {
    cursor: pointer;
}

.admin-nav {
    padding: 4px 8px;
    border-radius: 4px;
}

.admin-nav:hover {
    background: rgba(255, 255, 255, 0.3);
}
</style>
